import { hooks } from '@approvalmax/utils';

export const useGetQuoteSearchParams = () => {
    const [searchParams] = hooks.useUrlSearchParams();

    const companyId = searchParams.get('companyId');
    const requestId = searchParams.get('requestId');
    const code = searchParams.get('code');

    return { code, requestId, companyId };
};
